// extracted by mini-css-extract-plugin
export default {"aboutOurs":"About_aboutOurs__DHMUc","aboutOurs__text":"About_aboutOurs__text__TX4GS","images":"About_images__RXd4M","images__image":"About_images__image__DiNB8"};